import LegalLayout from "../components/LegalLayout";

const sections = [
  { id: "who-we-are", number: "01", label: "Who We Are" },
  { id: "mission", number: "02", label: "Our Mission" },
  { id: "learning", number: "03", label: "How We Teach" },
  { id: "programs", number: "04", label: "Our Programs" },
  { id: "learners", number: "05", label: "Who We Serve" },
  { id: "commitment", number: "06", label: "Our Commitment" },
  { id: "disclosure", number: "07", label: "Platform Disclosure" },
  { id: "contact", number: "08", label: "Contact Us" },
];

function Section({ id, number, title, children }) {
  return (
    <section id={id} className="legal-section">
      <div className="legal-section-heading">
        <span className="legal-section-number">{number}</span>
        <h2>{title}</h2>
      </div>

      {children}
    </section>
  );
}

function About() {
  return (
    <LegalLayout
      title="About CODEION"
      description="CODEION is an education-focused technology platform built around practical learning, structured programs, hands-on projects, and mentor-guided skill development."
      lastUpdated="July 2026"
      sections={sections}
    >
      <div className="legal-intro">
        We believe technology education should help learners move beyond
        theoretical concepts and develop practical skills through structured
        learning, consistent practice, projects, and guidance.
      </div>

      <Section id="who-we-are" number="01" title="Who We Are">
        <p>
          CODEION is an independent education-focused technology platform
          providing learning programs and resources for students, freshers, and
          professionals interested in developing practical technology skills.
        </p>

        <p>
          Our goal is to make learning structured, understandable, practical, and
          connected to real-world software development and technology workflows.
        </p>
      </Section>

      <Section id="mission" number="02" title="Our Mission">
        <p>
          Our mission is to help learners strengthen technical foundations and
          develop practical skills through guided learning paths, hands-on
          practice, projects, assignments, mentorship, and continuous learning.
        </p>
      </Section>

      <Section id="learning" number="03" title="Learning by Building">
        <p>
          CODEION programs are designed around the idea that technical skills are
          strengthened through active practice.
        </p>

        <ul>
          <li>Structured learning paths and technical foundations.</li>
          <li>Hands-on coding and practical exercises.</li>
          <li>Assignments and project-based learning.</li>
          <li>Live sessions or guided learning support where included.</li>
          <li>Mentorship and feedback depending on the selected program.</li>
          <li>Career-focused preparation where explicitly included in the program.</li>
        </ul>
      </Section>

      <Section id="programs" number="04" title="Our Programs">
        <p>
          CODEION may provide learning programs covering areas such as software
          development, full-stack development, frontend technologies, backend
          development, cloud computing, DevOps, artificial intelligence, data,
          and other modern technology skills.
        </p>

        <p>
          Program curriculum, duration, mentors, learning resources, projects,
          pricing, and included services may differ between programs.
        </p>
      </Section>

      <Section id="learners" number="05" title="Who We Serve">
        <p>Our learning services are designed for people including:</p>

        <ul>
          <li>College students building practical technical skills.</li>
          <li>Fresh graduates preparing for software and technology roles.</li>
          <li>Beginners looking for structured learning paths.</li>
          <li>Developers strengthening existing skills.</li>
          <li>Professionals exploring modern tools and technologies.</li>
        </ul>
      </Section>

      <Section id="commitment" number="06" title="Our Commitment">
        <p>
          CODEION is committed to improving its programs, technology, support,
          learning resources, and platform experience as the initiative grows.
        </p>

        <p>
          We aim to communicate program offerings clearly and avoid presenting
          educational services as guaranteed employment, salary, placement, or
          career outcomes.
        </p>
      </Section>

      <Section id="disclosure" number="07" title="Platform Disclosure">
        <p>
          CODEION is currently an independent educational initiative in an early
          growth stage and is working toward a more formally structured business
          and operational setup.
        </p>

        <p>
          CODEION is not affiliated with any government authority, university,
          certification authority, or employer unless such affiliation is
          explicitly stated.
        </p>

        <div className="legal-notice">
          Educational programs, mentorship, projects, certificates, and
          career-focused support do not guarantee employment, internships,
          salary outcomes, promotions, or selection by any employer.
        </div>
      </Section>

      <Section id="contact" number="08" title="Contact CODEION">
        <p>
          For questions about our programs, enrollments, collaborations,
          mentorship opportunities, or support, contact:
        </p>

        <p>
          Email:{" "}
          <a href="mailto:support@codeion.in">
            support@codeion.in
          </a>
        </p>

        <p>
          Support hours: Monday to Saturday, 10:00 AM to 7:00 PM IST.
        </p>
      </Section>

      <div className="legal-contact-card">
        <h2>Want to learn more about CODEION?</h2>

        <p>
          Explore our learning programs or contact our support team if you have
          questions about courses, enrollment, or the platform.
        </p>

        <a
          href="mailto:support@codeion.in"
          className="legal-contact-button"
        >
          Contact CODEION →
        </a>
      </div>
    </LegalLayout>
  );
}

export default About;